import styled, { css } from "styled-components";
import { SmallText } from "./HXDesktopPage.styles";
import { Title } from "./PatientConsentManagerShared.styles";
import { colors } from "healthex-common/colors";
import { fontSizes } from "healthex-common/sizes";
import { createFadeInAnimation, createSlideAnimation, createVerticalSlideAnimation } from "./animations.styles";
import { FlexColumn } from "./common.styles";
export const DetailsTextLink = styled(SmallText) `
    text-decoration: underline;
    padding: 0px;
`;
export const LogosContainer = styled.div `
    display: flex;
    align-items: center;
    justify-content: center;
    height: 88px;
    width: 205.7px;
    position: relative;
    align-self: center;
`;
const dashedLineAnimation = createVerticalSlideAnimation("0px", true);
export const DashedLineImage = styled.img `
    position: absolute;
    left: 92.4px;
    top: 44px;
    width: 20.9px;
    height: auto;

    ${(props) => props.animate &&
    css `
            animation: ${dashedLineAnimation} 400ms linear 400ms both;
        `}
`;
const orgLogoAnimation = createSlideAnimation("59px", "0px");
export const OrgLogoCircle = styled.div `
    position: absolute;
    left: 0;
    top: 0;
    width: 88px;
    height: 88px;
    border-radius: 50%;
    border: 0.917px solid rgba(29, 98, 174, 0.3);
    background-color: ${colors.white_main};
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    z-index: 2;
    overflow: hidden;

    ${(props) => props.animate &&
    css `
            animation: ${orgLogoAnimation} 400ms linear 400ms both;
        `}
`;
export const OrgLogoImage = styled.img `
    width: 100%;
    height: 100%;
    object-fit: contain;
`;
const healthExLogoAnimation = createSlideAnimation("-59px", "0px");
export const HealthExLogoCircle = styled.div `
    position: absolute;
    left: 117.7px;
    top: 0;
    width: 88px;
    height: 88px;
    border-radius: 50%;
    border: 0.917px solid rgba(29, 98, 174, 0.3);
    background: linear-gradient(135deg, #ffd881 0%, #ff8a2d 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    z-index: 1;
    overflow: hidden;

    ${(props) => props.animate &&
    css `
            animation: ${healthExLogoAnimation} 400ms linear 400ms both;
        `}
`;
export const HealthExLogoImage = styled.img `
    height: 29.33px;
    object-fit: cover;
`;
const topContainerAnimation = createVerticalSlideAnimation("calc(25vh - 25%)");
const fadeInAnimation = createFadeInAnimation(0, 1);
export const TopContainer = styled(FlexColumn) `
    gap: 16px;
    align-items: center;

    ${(props) => props.animate &&
    css `
            animation: ${topContainerAnimation} 400ms ease-out 400ms both;
        `};
`;
export const WelcomeTitle = styled(Title) `
    text-align: center;
    font-size: ${fontSizes.MOBILE_TITLE};
    line-height: 36px;
    font-weight: 500;
    color: ${colors.black_main};
`;
export const SupportingText = styled.p `
    font-size: ${fontSizes.STANDARD};
    font-weight: normal;
    line-height: normal;
    color: ${colors.black_light};
    text-align: center;
    letter-spacing: 0.15px;
    margin: 0;
    opacity: ${(props) => (props.animate ? 0 : 1)};

    ${(props) => props.animate &&
    css `
            animation: ${fadeInAnimation} 400ms ease-in 400ms forwards;
        `}
`;
